import { ApiPaginated } from '@cores/services/pagination';
import { ApiPaginatedComments } from './api-paginated-comments';
import { PaginatedComments } from './comments-service.interface';
import { CommentQueryGetter, CommentQuerySetter } from './comment-query-service.interface';
import { PaginatedCommentsImp } from './comments-service';
import { ApiGetComments } from '@/infrastructure/api-functions/api-get-comments';
import { WorkspaceApiServiceImpl } from '@/infrastructure/api-functions/workspace-api-service';
import { CommentQueryServiceImp } from './comment-query-service';
import { CommentsScopeService } from './comments-scope-service.interface';
import { CommentsScopeServiceImp } from './comments-scope-service';
import { ApiChangeCommentScope } from '@/infrastructure/api-functions/api-change-comment-scope';
import { CommentsSelectService } from './comments-select-service.interface';
import { CommentsSelectServiceImp } from './comments-select-service';
export function commentsModule(bind) {
    bind(ApiGetComments).to(WorkspaceApiServiceImpl);
    bind(ApiChangeCommentScope).to(WorkspaceApiServiceImpl);
    bind(ApiPaginated).to(ApiPaginatedComments).whenTargetNamed('paginated-comments');
    bind(PaginatedComments).to(PaginatedCommentsImp);
    bind(CommentQueryGetter).to(CommentQueryServiceImp);
    bind(CommentQuerySetter).to(CommentQueryServiceImp);
    bind(CommentsScopeService).to(CommentsScopeServiceImp);
    bind(CommentsSelectService).to(CommentsSelectServiceImp);
}
